import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="my-16">
      <Helmet>
        <title>{"Page Not Found"}</title>
      </Helmet>
      <div className="flex flex-col gap-7 justify-center items-center">
        <img className="w-[75%]" src="/404.png" />
        <p className="text-[18px] lg:text-[24px]">
          متاسفانه صفحه مورد نظر یافت نشد!
        </p>
        <span className="mt-2">
          <Link to={"/"} className="btn-brand">
            صفحه اصلی
          </Link>
        </span>
      </div>
    </div>
  );
};

export default NotFound;
